import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './FoodGallery.module.css';

const foodItems = [
  { image: '/Special/s1.png', name: 'દહીં ગાંઠિયા', nameEn: 'Dahi Gathiya' },
  { image: '/Special/s2.png', name: 'કાજુ લસણ', nameEn: 'Kaju Lasan' },
  { image: '/Special/s3.jpg', name: 'કાજુ કારેલા', nameEn: 'Kaju Karela' },
  { image: '/Special/s4.png', name: 'મકાઈ મુઠિયા', nameEn: 'Makai Muthiya' },
  { image: '/Special/s5.png', name: 'મકાઈ મેથી', nameEn: 'Makai Methi' }
];

const FoodGallery = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % foodItems.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const getVisibleItems = () => {
    const prevIndex = currentIndex === 0 ? foodItems.length - 1 : currentIndex - 1;
    const nextIndex = (currentIndex + 1) % foodItems.length;

    return [
      { ...foodItems[prevIndex], position: 'prev' },
      { ...foodItems[currentIndex], position: 'center' },
      { ...foodItems[nextIndex], position: 'next' }
    ];
  };

  const visibleItems = getVisibleItems();

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % foodItems.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? foodItems.length - 1 : prev - 1));
  };

  return (
    <section className={styles.gallery}>
      <div className={styles.container}>
        <h2 className={styles.title}>Our Delicious Varieties</h2>
        <p className={styles.subtitle}>અમારી સ્વાદિષ્ટ વેરાયટી</p>

        <div className={styles.sliderWrapper}>
          <button className={styles.arrowBtn} onClick={prevSlide} aria-label="Previous">
            ❮
          </button>

          <div className={styles.slider}>
            {visibleItems.map((item, index) => (
              <div 
                key={`${item.nameEn}-${index}`}
                className={`${styles.foodCard} ${item.position === 'center' ? styles.centerCard : ''}`}
              >
                <div className={styles.imageWrapper}>
                  <img src={item.image} alt={item.nameEn} className={styles.foodImage} />
                </div>
                <h3 className={styles.foodName}>{item.name}</h3>
                <p className={styles.foodNameEn}>{item.nameEn}</p>
              </div>
            ))}
          </div>

          <button className={styles.arrowBtn} onClick={nextSlide} aria-label="Next">
            ❯
          </button>
        </div>

        <div className={styles.indicators}>
          {foodItems.map((_, index) => (
            <span
              key={index}
              className={`${styles.indicator} ${index === currentIndex ? styles.activeIndicator : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>

        {/* ⭐ NEW BUTTON ADDED HERE */}
        <button className={styles.viewMoreBtn} onClick={() => navigate('/specials')}>
          વધુ જુઓ 
        </button>

      </div>
    </section>
  );
};

export default FoodGallery;
